export const ValidIcon = () => (
  <svg width="35" height="26" viewBox="0 0 35 26" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.0469 25.6748L35 3.01517L32.5 0.515171L12 20.5152L2.99998 11.5152L0.453481 14.2506L12.0469 25.6748Z"
      fill="currentColor"
    />
  </svg>
);
